module.exports = __webpack_public_path__ + "assets/mark.9165fa0d.svg";